export const TID = {
  countdown: "sticky-countdown",
  heroBuyBtn: "hero-buy-now-btn",
  stickyBuyBtn: "sticky-buy-now-btn",
  pricingPrepaid: "pricing-card-prepaid",
  pricingCod: "pricing-card-cod",
  pricingMrp: "pricing-card-mrp",
  pricingBuyPrepaid: "pricing-buy-prepaid",
  pricingBuyCod: "pricing-buy-cod",
  primaryBuyBtn: "primary-buy-now",
  finalBuyBtn: "final-buy-now",
  modal: "purchase-modal",
  modalPrepaid: "modal-select-prepaid",
  modalCod: "modal-select-cod",
  modalName: "modal-input-name",
  modalPhone: "modal-input-phone",
  modalEmail: "modal-input-email",
  modalAddress: "modal-input-address",
  modalCity: "modal-input-city",
  modalState: "modal-input-state",
  modalPincode: "modal-input-pincode",
  modalConfirm: "modal-confirm-order",
  modalBack: "modal-back",
  modalCoupon: "modal-coupon-input",
  modalCouponApply: "modal-coupon-apply",
  whatsappBtn: "floating-whatsapp",
  faqItem: "faq-item",
  successBanner: "order-success-banner",
  // Admin
  adminPasswordInput: "admin-password-input",
  adminLoginBtn: "admin-login-btn",
  adminLogoutBtn: "admin-logout-btn",
  adminOrdersTable: "admin-orders-table",
  adminStatCards: "admin-stat-cards",
  adminOrderRow: "admin-order-row",
  adminStatusSelect: "admin-status-select",
  adminExportCsv: "admin-export-csv",
  adminTabOrders: "admin-tab-orders",
  adminTabCoupons: "admin-tab-coupons",
  adminTabAnalytics: "admin-tab-analytics",
  adminCouponsTable: "admin-coupons-table",
  adminCouponRow: "admin-coupon-row",
  adminCouponAddBtn: "admin-coupon-add",
  adminCouponCodeInput: "admin-coupon-code-input",
  adminCouponDiscountInput: "admin-coupon-discount-input",
  adminCouponLabelInput: "admin-coupon-label-input",
  adminCouponSubmit: "admin-coupon-submit",
  adminCouponToggle: "admin-coupon-toggle",
  adminCouponDelete: "admin-coupon-delete",
  adminAnalyticsCards: "admin-analytics-cards",
  adminAnalyticsSource: "admin-analytics-source",
  adminAnalyticsCampaign: "admin-analytics-campaign",
};
